import Serializer from "../../serializer";
import { SkillModel } from "./models";
import { JSONAPIDocument } from "json-api-serializer";
import { IMSTArray } from "mobx-state-tree";

export function deserializeSkills(data: JSONAPIDocument): IMSTArray<typeof SkillModel> {
  return Serializer.deserialize("skills", data);
}
